import {REPORT_LISTING_MODAL_QUERY_OPERATION_NAME} from '../queries/reportListingModalQuery';
export const BEX_API_OPERATIONS = [REPORT_LISTING_MODAL_QUERY_OPERATION_NAME];
